import { Box, Container } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import ComboBox from '../../Components/ComboBox'
import CustomButton from '../../Components/CustomButton/CustomButton'
import { makeGetRequest, makePostRequest } from '../../utils/api'
import urls from '../../utils/urls'
import CreateObjectifsForm from './CreateObjectifsForm'
import ListObjectifs from './ListObjectifs'
export const MesOjectifs = () => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const { setValue, handleSubmit } = useForm({
    defaultValues: {
      domain: '',
      objectifs: '',
      perodicity: '',
      status: '',
    },
  })
  const navigate = useNavigate()
  const location = useLocation()

  const [objectifs, setObjectifs] = useState({})
  const [objectifsMetadata, setObjectifsMetaDeta] = useState({})

  const [selectedRows, setSelectedRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [openWorkTimeFromUrl, setOpenWorkTimeFromUrl] = useState(false)
  const [openFromAdvisor, setOpenFromAdvisor] = useState(false) // LAP-CP05

  useEffect(() => {
    fetchMesObjectifsMetaData()
  }, [])

  useEffect(() => {
    fetchObjectifs()
  }, [location.search])
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const urlAction = searchParams.get('action') || searchParams.get('modal')

    if (urlAction === 'new-work-time') {
      setOpenWorkTimeFromUrl(true)
    }
    // LAP-CP05 — Ouverture depuis le Conseiller Patrimonial avec un prefill
    // transmis via location.state.prefill. TODO : étendre CreateObjectifsForm
    // pour lire ce prefill et pré-remplir le dialog (domain, montant, périodicité).
    if (urlAction === 'new-from-advisor') {
      setOpenFromAdvisor(true)
    }
  }, [location.search])
  const fetchObjectifs = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.crudMesObjectifs}?${location.search.slice(1)}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setObjectifs({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }

  const fetchMesObjectifsMetaData = async () => {
    const response = await makeGetRequest(urls.fetchMesObjectifsMetaData, {}, true)
    if (response.status === 200) {
      const domains = []
      const frequency = []
      const predefinedObjectives = []
      const status = [{ label: 'En cours' }, { label: 'Annulé' }, { label: 'reussite' }]
      response.data.domains.forEach((v) => {
        domains.push({ label: v.domain, id: v.id })
      })
      response.data.frequency.forEach((v) => {
        frequency.push({ label: v.name_of_periodicity, id: v.id })
      })
      response.data.predefined_objectives.forEach((v) => {
        predefinedObjectives.push({
          label: v.objectives_name,
          id: v.id,
          domain: v.domain,
          value: v.value_format,
        })
      })
      setObjectifsMetaDeta({
        domains,
        frequency,
        predefinedObjectives,
        status,
      })
    }
  }
  const filterObjectifs = (data) => {
    const payload = {
      domain: data.domain?.label || '',
      status: data.status?.label || '',
      periodicity: data.periodicity?.label || '',
      objectives_name: data.objectifs?.label || '',
    }
    const queryParams = new URLSearchParams(payload).toString()
    navigate(`?${queryParams}`)
  }

  const deleteBulkObjectifs = async () => {
    if (selectedRows.length === 0) {
      alert(t('mesObjectifs.selectObjectiveAlert'))
    } else {
      objectifs.results.forEach((v) => {
        if (selectedRows.includes(v.id)) {
          return (v.status = 'Annulé')
        }
      })

      setObjectifs({
        ...objectifs,
      })
      const response = await makePostRequest(
        urls.bulkObjectifsAnnuler,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
      }
    }
  }
  return (
    <>
      {/* <Box bgcolor={"#001b42"} p={1}>
        <Container maxWidth="xl">
          <form onSubmit={handleSubmit(filterObjectifs)}>
            <Box display={"flex"} justifyContent="flex-start" flexWrap="wrap">
              <Box bgcolor={"white"} mr={2}>
                <ComboBox
                  handleAutoComplete={(e, j) => setValue("domain", j)}
                  label="Domaine"
                  data={objectifsMetadata.domains || []}
                  name="domain"
                  variant="filled"
                />
              </Box>
              <Box bgcolor={"white"} mr={2}>
                <ComboBox
                  handleAutoComplete={(e, j) => setValue("objectifs", j)}
                  label="Objectif"
                  data={objectifsMetadata.predefinedObjectives || []}
                  name="objectifs"
                  style={{ minWidth: "250px", backgroundColor: "white" }}
                  variant="filled"
                />
              </Box>
              <Box bgcolor={"white"} mr={2}>
                <ComboBox
                  handleAutoComplete={(e, j) => setValue("periodicity", j)}
                  label="Périodicité"
                  data={objectifsMetadata.frequency || []}
                  name="periodicity"
                  variant="filled"
                />
              </Box>
              <Box bgcolor={"white"} mr={2}>
                <ComboBox
                  handleAutoComplete={(e, j) => setValue("status", j)}
                  label="Statut"
                  data={objectifsMetadata.status}
                  name="statut"
                  variant="filled"
                />
              </Box>
              <CustomButton type="submit">Filter</CustomButton>
            </Box>
          </form>
        </Container>
      </Box> */}
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          <Box>
            {/* <UploadOperations /> */}
            <CreateObjectifsForm
              objectifsMetadata={objectifsMetadata}
              setObjectifs={setObjectifs}
              openFromUrl={openWorkTimeFromUrl || openFromAdvisor /* LAP-CP05 */}
              selectedVal="Temps de travail"
              onUrlOpenConsumed={() => {
                setOpenWorkTimeFromUrl(false)
                setOpenFromAdvisor(false) // LAP-CP05
                navigate(location.pathname, { replace: true })
              }}
            />
            <CustomButton onClick={deleteBulkObjectifs}>{t('mesObjectifs.cancel')}</CustomButton>
          </Box>
        </Box>

        <ListObjectifs
          fetchObjectifs={fetchObjectifs}
          setSelectedRows={setSelectedRows}
          objectifs={objectifs}
        />
      </Container>
    </>
  )
}
